import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-protected-area',
    templateUrl: './protected-area.component.html',
    styleUrls: [
        './protected-area.component.scss'
    ],
    standalone: false
})
export class ProtectedAreaComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
